import ButtonMui from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
 import styled from 'styled-components';

 export const Wrap = styled.div`
 z-index: 2000 !important;
    
`;

 export const WrapPopover = styled(Popover)`
    z-index: 2000 !important;
    .MuiPopover-paper {        
        width: 236px;
        border: 0.1px solid gray;
        border-radius: 5px;
        padding: 2px;
        min-width: 25px;
        overflow-x: initial;
        overflow-y: initial;
        box-shadow: none;
    }
    .divButtons {
        display: flex;                
        justify-content: space-between;
        width: 190px;
        margin-left: 20px;
        
    }
    .buttonsColorPicker {
        width: 113px;
        height: 30px;
        margin: 10px 0px;
    }    
    .rcp-body {
        margin-bottom: -10px;
    }
    .rcp-saturation {   
        border-radius: 4px !important;
        border-bottom-left-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
    }
    .rcp-fields-element {
        width: 190px;
        display: -webkit-flex;
        -webkit-flex-direction: column-reverse;
        flex-direction: column-reverse !important;
        label {            
            display: flex;
            width: 100%;
            left: 10px;
            color: #6B6B6B;
            margin-bottom: -2px;
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
        }
        input {
            border: 0.1px solid #707070;
            border-radius: 3px;
            color: #757575;
        }
    }
`;

/**
* Estilização do componente ButtonSave
*/
export const ButtonSave = styled(ButtonMui)`
&.MuiButton-root {
    background: #3c71dd;
    border-radius: 3px;
    width: 90px;
    height: 32px;
    margin-left: 16px;

 &:hover {
    background: #303f9f;
}

 &.Mui-disabled {
    background: #aeaeae;
 }

 .MuiButton-label {
   font-family: Roboto;
   font-style: normal;
   font-weight: 600;
   font-size: 14px;
   line-height: 22px;
   text-align: center;
   color: #ffffff;
   text-transform: none;
 }    
}  
`;

/**
* Estilização do componente ButtonCancel
*/
export const ButtonCancel= styled(ButtonMui)`
    &.MuiButton-root {
        background: #aeaeae;
        border-radius: 3px;
        width: 102px;
        height: 32px;

    &:hover {
        background: #3c71dd;
    }

    .MuiButton-label {
        font-family: Roboto;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: #ffffff;
        text-transform: none;
    }    
    }  
`;